/* eslint-disable no-case-declarations */
import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";
import { Inject } from '@syncfusion/ej2-react-grids';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { Count, HtmlEditor, QuickToolbar, RichTextEditorComponent, Toolbar as rteToolbar } from '@syncfusion/ej2-react-richtexteditor';
//import { Toast } from 'primereact/toast';
import { useCallback, useEffect, useState } from 'react';
import { LoadAPIData, SaveAPIData } from '../helpers/DataHelper';
import { GetYesNoList } from '../helpers/Lookup';
import { showToast } from '../helpers/ToastHelper';
import { fieldRequired } from '../helpers/validation';

export default function Notifications() {
  //const toastRef = useRef(null);
  const [editData, setEditData] = useState();
  const [editId, setEditId] = useState(0);

  const [isActive, setIsActive] = useState(0);
  const [title, setTitle] = useState('');
  const [copy, setCopy] = useState('');
  
  const [editModal, setEditModal] = useState(false);

  const toggle = () => setEditModal(!editModal);

  const SimpleToolbarSettings = {
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
      'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
      'LowerCase', 'UpperCase', '|', 'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
      'Outdent', 'Indent', '|', 'CreateLink', 'Image', '|', 'ClearFormat',
      'SourceCode', 'FullScreen', '|', 'Undo', 'Redo'
    ],
    type: 'Expand'
  };

  const loadData = useCallback(async () => {
    const data = await LoadAPIData('/api/notifications/1');
    setEditData(data);
    editItem(1, data);
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const editItem = (id, data) => {
    if (id > 0) {
      const item = data ?? editData;
      //console.log(item);
      setEditId(item.id);
      setIsActive(item.isActive);
      setTitle(item.title);
      setCopy(item.copy);
    }
    else {
      //clear state fields
      setEditId(0);
      setIsActive(0);
      setTitle('');
      setCopy('');
    }
    setEditModal(true);
  };

  const validateForm = () => {
    var valid = true;
    valid &= fieldRequired(copy, 'tbTitleError', '* required', 'tbTitle');

    return valid;
  }

  const saveItem = async (event) => {
    event.stopPropagation();

    if (validateForm()) {
      const data = { id: editId, isActive: isActive, title: title, copy: copy,  };

      const result = await SaveAPIData('/api/notifications', data, (editId === 0 ? 'POST' : 'PUT'));
      if (result.success) {
        loadData();
        //toastRef.current.show({ severity: 'success', summary: 'Notifications', detail: 'The notifications was successfully saved!', life: 3000 });
        showToast("success", 'Notifications', 'The notification was successfully saved!');
      }
      else {
        //toastRef.current.show({ severity: 'error', summary: 'Notifications', detail: 'There was an error saving the notifications!', life: 3000 });
        showToast("error", 'Notifications', 'There was an error saving the notification!');
      }
      toggle();
    }
  }
 
  return (
    <>
      <h1>Notifications</h1>
      <div className="card mt-4">
        <div className="card-body">
          <div className="row">
            
            <div className='mb-3 col-md-9'>
              <TextBoxComponent id='tbTitle' name='tbTitle' placeholder='Title' maxLength='250' floatLabelType='Auto' showClearButton={true} value={title} onChange={e => setTitle(e.value)} />
              <div id='tbTitleError' className='error-message' />
            </div>
            <div className='mb-3 col-md-3'>
              <DropDownListComponent id='tbIsActive' name='tbIsActive' placeholder='Is Active' dataSource={GetYesNoList} fields={{ text: 'text', value: 'value' }} floatLabelType='Always' value={isActive} change={e => setIsActive(e.itemData.value)} />
            </div>

          </div>

          <label for='tbCopy'>Copy<span className='ErrorText ms-1'>*</span> <span id='errCopy' className='ErrorText' /></label>
          <RichTextEditorComponent id='tbCopy' name='tbCopy' height={300} placeholder='Copy' toolbarSettings={SimpleToolbarSettings} showCharCount={true} value={copy} change={e => setCopy(e.value)} >
            <Inject services={[rteToolbar, HtmlEditor, QuickToolbar, Count]} />
          </RichTextEditorComponent>
          <div id='tbCopyError' className='error-message' />
          <hr />
          <div className="text-end">
            <button className="btn btn-sm btn-success" onClick={saveItem}>Save <i className="far fa-check-circle ms-2"></i></button>  
          </div>
        </div>
      </div>



    </>
  );
}

